import React, { useEffect, useMemo, useState } from "react";
import { Col, Container, Modal, Row, Table } from "reactstrap";
import "@fullcalendar/bootstrap/main.css";
// import "../../../assets/css/Work/digitalMarketing.css"
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "pages/Separate/Loader";
import secureLocalStorage from "react-secure-storage";
import moment from "moment";
import { fetchNodeData, FetchNodePostData } from "utils/common-fetchData";
import {
  convertMinutesToTimeString,
  getFormattedTime,
  getInitials,
} from "utils/common-helpers";
import configure from "configure";
import viewImg from "../../assets/images/Inventory/viewImg.jpg";
import NewPagination from "components/Common/Newpagination";
import { useTable, usePagination, useSortBy } from "react-table";
import { timeSheetColumns } from "utils/columns/ElementsColumns/supportColumns";
import axios from "axios";
import * as XLSX from "xlsx";
import { otherProjectsList } from "utils/common-options";
import Swal from "sweetalert2";

const TimeSheetReport = (props) => {
  document.title = "Timesheet Report | Zithas Crm";

  const [modal, setModal] = useState(false);

  const [allProjects, setAllProjects] = useState([]);

  const [staff, setStaff] = useState([]);
  const [projectOptions, setprojectOptions] = useState([]);
  const [digital_projects, setdigital_projects] = useState([]);

  // getting all staff & projects
  useEffect(() => {
    const fetch = async () => {
      try {
        const authToken = secureLocalStorage.getItem("auth_token");
        const datas = await fetchNodeData(toggleLoading, "generalData", authToken);

        const allStaffOption = datas?.data?.staff?.map((obj) => {
          return {
            label: obj?.name,
            value: obj.id,
          };
        });

        const devProjects = datas?.data?.projects?.map((obj) => {
          return {
            label: obj?.project_name,
            value: obj.id,
          };
        });

        const dmProjects = datas?.data?.digital_projects?.map((obj) => {
          return {
            label: obj?.project_name,
            value: obj.id,
          };
        });

        setprojectOptions(devProjects || []);
        setdigital_projects(dmProjects || []);
        setStaff(allStaffOption || []);
      } catch (err) {
        console.log(err);
      }
    };

    fetch();
  }, []);

  // making all projects data
  useEffect(() => {
    if (projectOptions?.length || digital_projects?.length) {
      setAllProjects([
        ...projectOptions.map((p) => ({
          ...p,
          label: `${p.label} - Dev`,
          type: 0,
        })),
        ...digital_projects.map((p) => ({
          ...p,
          label: `${p.label} - DM`,
          type: 1,
        })),
        ...otherProjectsList,
      ]);
    }
  }, [projectOptions, digital_projects]);

  const [isLoading, setLoading] = useState(false);
  const [toDate, setToDate] = useState("");
  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [users, setUsers] = useState([]);

  const [isSearch, setIsSearch] = useState(false);
  const [activeUser, setActiveUser] = useState(null);

  const toggleLoading = (loading) => {
    setLoading(loading);
  };

  useEffect(() => {
    if (activeUser && toDate)
      getDataByDate({ value: activeUser }, toDate, toDate);
  }, [activeUser]);

  // get timesheet data by date and user

  const getDataByDate = async (
    selectedStaff,
    fromDate,
    toDate,
    selectedDate = moment().format("YYYY-MM-DD"),
  ) => {
    try {
      if (!fromDate || !toDate) {
        swal("", "From and To Date is required!", "warning");
        return;
      }
      setLoading(true);
      setData([]);

      const workLoadUrl = `${configure.nodeApi}/TimeSheetReport/${fromDate}/${toDate}/${selectedStaff.value}`;
      const pendingTaskUrl = `${configure.nodeApi}/pendingTasks/${selectedStaff.value}/${fromDate}/${toDate}`;

      const res = await axios.get(workLoadUrl);

      const res2 = await axios.get(pendingTaskUrl);

      if (res?.data?.success) {
        const fetchedData = res.data.data.allData || [];

        const currentUserId = selectedStaff.value;

        const filteredData = fetchedData
          .filter((item) => {
            const isOwner =
              item.user_id === currentUserId ||
              item.staff_id === currentUserId ||
              // item.added_by === currentUserId ||
              item?.user?.id === currentUserId;

            // const isAssigned = item.assigned
            //   ? item.assigned
            //       .split(",")
            //       .map(id => Number(id.trim()))
            //       .includes(currentUserId)
            //   : false

            const hasTime = item.total_actual_time;

            return isOwner && hasTime;
          })
          ?.map((item) => ({
            ...item,
            date: moment(item.updated_at).format("DD-MM-YYYY"),
            ...(item.type != "activity" &&
              item?.timelogs && {
                todayTime: getFormattedTime(item?.timelogs || []) || null,
              }),
          }));

        setData(filteredData);
      } else {
        console.warn("Workload API returned success=false", res?.data);
      }

      if (res2?.data?.success) {
        setRows(res2.data.data);
      } else {
        console.warn("PendingTasks API returned success=false", res2?.data);
      }

      setLoading(false);
      console.log("Loading set to FALSE");
      console.log("========== getDataByDate END ==========");
    } catch (error) {
      console.error("❌ Error in getDataByDate:", error);
      console.log("Selected Date:", selectedDate);
      console.log("Selected Staff:", selectedStaff);

      setLoading(false);
      console.log("Loading set to FALSE due to error");
    }
  };

  // getting user based on date selection
  const handleGetUsers = async () => {
    try {
      if (!toDate) swal("", "Please select Date", "warning");
      setActiveUser(null);

      const token = secureLocalStorage.getItem("auth_token");
      const auth_id = localStorage.getItem("auth_id");

      const res = await fetchNodeData(
        setLoading,
        `pendingTasks/getClosedData/${toDate}`,
        token,
      );
      if (res.success) {
        const list = res.data
          // ?.filter(user => user.id !== 1)
          ?.map((user) => ({
            label: user.name,
            value: user.id,
            avatar: user.avatar,
            isClosed: user.isClosed,
            isAllowed: user.isAllowed,
          }));
        setUsers(list);

        if (list.filter((l) => l.isClosed).length) {
          setActiveUser(list.filter((l) => l.isClosed)[0].value);
          setIsSearch(true);
        } else {
          setIsSearch(false);
        }
      }
      console.log("res.users", res);
    } catch (error) {
      console.error("Submit pending tasks error:", error);
      swal("", "Something went wrong!", "error");
    }
  };

  // const totalUsedTime = useMemo(() => {

  //   if (rows.length || data.length) {
  //     const allTimes = []
  //     rows.forEach(item => {
  //       if (item.approved == 1) {
  //         allTimes.push(item.totaltime)
  //       }
  //     })

  //     data.forEach(item => allTimes.push(item.todayTime || "00:00:00"))

  //     const total = allTimes.reduce((acc, time) => {
  //       const [h, m, s] = time.split(":").map(Number)
  //       return (
  //         acc +
  //         moment.duration({ hours: h, minutes: m, seconds: s }).asSeconds()
  //       )
  //     }, 0)

  //     const totalTime = moment.utc(total * 1000).format("HH:mm:ss")

  //     return totalTime
  //   } else {
  //     return "00:00:00"
  //   }
  // }, [rows, data])

  //   useEffect(() => {
  //     if (selectedStaff?.length != 0 && isSearch) {
  //       onGetDetails(currentMonth)
  //     }
  //   }, [currentMonth, isSearch])

  // calculating total time
  const totalUsedTime = useMemo(() => {
    if (!rows.length && !data.length) return "00:00:00";

    const getSeconds = (timeString, type) => {
      if (!timeString) return 0;

      // If activity → format is HH:mm
      if (type === "activity") {
        const [h = 0, m = 0] = timeString.split(":").map(Number);
        return h * 3600 + m * 60;
      }

      // Normal case → HH:mm:ss
      const [h = 0, m = 0, s = 0] = timeString.split(":").map(Number);
      return h * 3600 + m * 60 + s;
    };

    let totalSeconds = 0;

    rows.forEach((item) => {
      if (item.approved == 1) {
        totalSeconds += getSeconds(item.totaltime);
      }
    });

    data.forEach((item) => {
      if (item.type === "activity" || item.type === "qa_task") {
        if (item.type === "qa_task") {
          totalSeconds += getSeconds(
            convertMinutesToTimeString(item.total_actual_time || 0),
            "activity",
          );
        } else {
          totalSeconds += getSeconds(item.total_actual_time, "activity");
        }
      } else {
        totalSeconds += getSeconds(item.todayTime);
      }
    });

    return moment.utc(totalSeconds * 1000).format("HH:mm:ss");
  }, [rows, data]);

  const totalIncludingAdditionalTime = useMemo(() => {
    if (!rows.length && !data.length) return "00:00:00";

    const getSeconds = (timeString, type) => {
      if (!timeString) return 0;

      // If activity → format is HH:mm
      if (type === "activity") {
        const [h = 0, m = 0] = timeString.split(":").map(Number);
        return h * 3600 + m * 60;
      }

      // Normal case → HH:mm:ss
      const [h = 0, m = 0, s = 0] = timeString.split(":").map(Number);
      return h * 3600 + m * 60 + s;
    };

    let totalSeconds = 0;

    rows.forEach((item) => {
      totalSeconds += getSeconds(item.totaltime);
    });

    data.forEach((item) => {
      if (item.type === "activity" || item.type === "qa_task") {
        if (item.type === "qa_task") {
          totalSeconds += getSeconds(
            convertMinutesToTimeString(item.total_actual_time || 0),
            "activity",
          );
        } else {
          totalSeconds += getSeconds(item.total_actual_time, "activity");
        }
      } else {
        totalSeconds += getSeconds(item.todayTime);
      }
    });

    return moment.utc(totalSeconds * 1000).format("HH:mm:ss");
  }, [rows, data]);

  const columns = useMemo(() => timeSheetColumns(true), []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    gotoPage,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useSortBy,
    usePagination,
  );

  // export timesheet
  const handleExport = () => {
    const workbook = XLSX.utils.book_new();

    const modifyArr = [];

    data.forEach((list) => {
      modifyArr.push({
        ["Sr No."]: modifyArr.length + 1,
        Type: list.type,
        ["Activity Name"]: list.task_title,
        Date: list.date,
        ["Start Time"]: moment(list.start_time).format("hh:mm A"),
        ["End Time"]: moment(list.end_time).format("hh:mm A"),
        ["Total Time"]:
          (list.type == "activity" ? list.total_actual_time : list.todayTime) +
          " hrs",
        Approval: "--",
      });
    });

    rows.forEach((list) => {
      modifyArr.push({
        ["Sr No."]: modifyArr.length + 1,
        Type: "Manual",
        ["Activity Name"]: list.title,
        Date: moment(list.date).format("DD-MM-YYYY"),
        ["Start Time"]: moment(list.start_time, "HH:mm").format("hh:mm A"),
        ["End Time"]: moment(list.end_time, "HH:mm").format("hh:mm A"),
        ["Total Time"]: list.totaltime + " hrs",
        Approval:
          list.approved == 1
            ? "Approved"
            : list.approved == 0
            ? "Pending"
            : "Disapproved",
      });
    });

    modifyArr.push({ ["Total Time Taken"]: totalUsedTime + " hrs" });

    const worksheet = XLSX.utils.json_to_sheet(modifyArr);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      `${
        staff?.find((s) => s.value == activeUser)?.label || "User"
      }_timesheet_report.xlsx`,
    );
  };

  const totalHours = useMemo(() => {
    let totalSeconds = 0;

    rows.forEach((r) => {
      const [h = 0, m = 0, s = 0] = r?.totaltime?.split(":").map(Number);
      totalSeconds += h * 3600 + m * 60 + s;
    });

    const d = moment.duration(totalSeconds, "seconds");
    return `${String(Math.floor(d.asHours())).padStart(2, "0")}:${String(
      d.minutes(),
    ).padStart(2, "0")}:${String(d.seconds()).padStart(2, "0")}`;
  }, [rows]);

  const totalPendingHours = useMemo(() => {
    let totalSeconds = 0;

    rows
      ?.filter((item) => item.approved != 1)
      ?.forEach((r) => {
        const [h = 0, m = 0, s = 0] = r?.totaltime?.split(":").map(Number);
        totalSeconds += h * 3600 + m * 60 + s;
      });

    const d = moment.duration(totalSeconds, "seconds");
    return `${String(Math.floor(d.asHours())).padStart(2, "0")}:${String(
      d.minutes(),
    ).padStart(2, "0")}:${String(d.seconds()).padStart(2, "0")}`;
  }, [rows]);

  async function handleAllowFill(user) {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: `You want to allow ${
          user.label
        } to fill timesheet for        ${moment(toDate).format(
          "DD-MMM-YYYY",
        )} ?`,
        icon: "warning",
        showCancelButton: true,
      });

      if (!result.isConfirmed) return;

      const payload = {
        id: user.value,
        date: toDate,
      };

      const response = await FetchNodePostData(
        setLoading,
        "TimeSheetReport/pastTimesheetReport",
        secureLocalStorage?.getItem("auth_token"),
        payload,
      );
      if (response.data.success) {
        setUsers((prev) =>
          prev.map((u) => {
            if (u.value == user.value) u.isAllowed = true;
            return u;
          }),
        );
      } else {
        swal("", response.data.message || "Something went wrong!", "error");
      }
    } catch (error) {
      console.log(error);
      swal("", "Something went wrong!", "error");
    }
  }

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumb title="Reports" breadcrumbItem="Timesheet Report" />

          {/* Header */}
          <div className="card p-4 h-100 mb-3">
            <div className="row align-items-end ">
              <div className="col-md-2">
                {/* <label htmlFor="">Select Date</label> */}
                <input
                  type="date"
                  className="form-control"
                  placeholder="To Date"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                  max={new Date().toISOString().split("T")[0]}
                />
              </div>

              <div className="col-md-1">
                <button
                  className="btn bg-purple text-white"
                  onClick={() => {
                    handleGetUsers();
                    // getDataByDate(selectedStaff, toDate, toDate)
                  }}
                >
                  <i className="bi bi-funnel-fill me-1"></i> Filter
                </button>
              </div>

              <div className="col-md-9 ps-5 fs-5 text-end align-self-center d-flex justify-content-end gap-4">
                {users.length ? (
                  <>
                    {users?.filter((u) => u.isClosed).length} out of{" "}
                    {users.length} employees have submitted their timesheets.
                    check who has not yet submitted.{" "}
                    <div
                      className={`nav-item dropdown approval-list px-0 general-box cursor-pointer`}
                    >
                      <h5
                        className="text-purple mb-0 d-flex align-items-center justify-content-between px-2"
                        onClick={() => setModal(true)}
                      >
                        Check here
                      </h5>
                    </div>
                  </>
                ) : null}
              </div>
            </div>
          </div>

          {/* Main Content */}
          {isSearch ? (
            <div className="card p-3 pe-0">
              <div className="row mx-0">
                <div
                  className="col-md-2 py-3"
                  style={{
                    maxHeight: "500px",
                    overflow: "auto",
                    scrollbarWidth: "thin",
                    backgroundColor: "#f0e8f4",
                  }}
                >
                  {users
                    ?.filter((u) => u.isClosed)
                    ?.map((user) => {
                      return (
                        <div
                          key={user.value}
                          style={{ userSelect: "none", cursor: "pointer" }}
                          className={`d-flex align-items-center gap-3 px-2 py-2 rounded mb-2 
                          ${
                            user.value == activeUser ? "bg-purple" : "bg-white"
                          } shadow`}
                          onClick={() => setActiveUser(user.value)}
                        >
                          <div>
                            {!user.avatar ? (
                              <img
                                src={`${configure.imgUrl}/images/1756277819.jfif`}
                                alt=""
                                className="assigned-img p-1 bg-light"
                                style={{ width: "30px", height: "30px" }}
                              />
                            ) : (
                              <div className="header-default-img">
                                {getInitials(user.label || "z")}
                              </div>
                            )}
                          </div>
                          <div>{user.label}</div>
                        </div>
                      );
                    })}
                </div>
                <div className="col-md-10">
                  <div className="card p-4 h-100">
                    <Row>
                      <Col className="col-12 hr-report">
                        <Row>
                          {/* ================= LEFT : MAIN TABLE ================= */}
                          <Col md="12" className="pb-4">
                            <div className="d-flex align-items-start justify-content-between mb-3">
                              <div className="d-flex align-items-start gap-3">
                                <div className=" text-purple fs-5 fw-bold  mb-3 mt-1">
                                  Assigned Tasks
                                </div>
                                <div className="general-box bg-light ml-3 px-3 fw-semibold text-purple">
                                  Verified Time : {totalUsedTime}
                                </div>
                                <div className="general-box bg-light ml-3 px-3 fw-semibold text-purple">
                                  Unverified Time : {totalPendingHours}
                                </div>
                                <div
                                  className="general-box ml-3 px-3 fw-semibold text-purple"
                                  style={{
                                    color: "purple",
                                    border: "1px solid purple",
                                  }}
                                >
                                  Total Time : {totalIncludingAdditionalTime}
                                </div>
                              </div>

                              <div>
                                {data.length || rows.length ? (
                                  <button
                                    onClick={handleExport}
                                    className="btn-success btn"
                                  >
                                    <i className="fas fa-download me-2"></i>{" "}
                                    Export Timesheet
                                  </button>
                                ) : null}
                              </div>
                            </div>

                            <div className="table-responsive">
                              <Table bordered {...getTableProps()}>
                                <thead>
                                  {headerGroups.map((hg, i) => (
                                    <tr key={i} {...hg.getHeaderGroupProps()}>
                                      {hg.headers.map((col, idx) => (
                                        <th
                                          key={idx}
                                          {...col.getHeaderProps(
                                            col.getSortByToggleProps(),
                                          )}
                                          className={col.className}
                                        >
                                          {col.render("Header")}
                                        </th>
                                      ))}
                                    </tr>
                                  ))}
                                </thead>

                                <tbody {...getTableBodyProps()}>
                                  {page.map((row, i) => {
                                    prepareRow(row);
                                    return (
                                      <tr key={i} {...row.getRowProps()}>
                                        {row.cells.map((cell, idx) => (
                                          <td
                                            key={idx}
                                            {...cell.getCellProps()}
                                            className={cell.column.className}
                                          >
                                            {cell.render("Cell")}
                                          </td>
                                        ))}
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </Table>
                            </div>
                            <NewPagination
                              gotoPage={gotoPage}
                              canPreviousPage={canPreviousPage}
                              previousPage={previousPage}
                              canNextPage={canNextPage}
                              pageIndex={pageIndex}
                              pageOptions={pageOptions}
                              pageSize={pageSize}
                              page={page}
                              data={data}
                              nextPage={nextPage}
                            />
                          </Col>

                          {/* ================= RIGHT : TASK TIME DETAILS ================= */}
                          <Col md="12" className="pt-4 border-top">
                            {/* ===== Header with Submit Button ===== */}
                            <div className="d-flex justify-content-between align-items-center mb-2">
                              <div className="text-purple fs-5 fw-bold">
                                Manually Added Tasks
                              </div>

                              <h5 className="text-purple mb-0">
                                Total Hours :
                                <span className="text-primary ms-2">
                                  {totalHours}
                                </span>
                              </h5>
                            </div>

                            <div>
                              <Table bordered>
                                <thead>
                                  <tr>
                                    <th className="text-center">#</th>
                                    <th>Project</th>
                                    <th>Activity Name</th>
                                    <th className="col-2 text-center">Date</th>
                                    <th className="text-center">Start Time</th>
                                    <th className="text-center">End Time</th>
                                    <th className="text-center">Total Time</th>
                                    <th className="text-center">Approval</th>
                                  </tr>
                                </thead>

                                <tbody>
                                  {rows.map((row, i) => (
                                    <tr key={i}>
                                      <td className="text-center">{i + 1}</td>
                                      <td>
                                        {allProjects?.find(
                                          (s) =>
                                            (row.project_type == 2
                                              ? s.value == row.other_project_id
                                              : s.value == row.project_id) &&
                                            s.type == row.project_type,
                                        )?.label || ""}
                                      </td>

                                      <td className="text-capitalize">
                                        {row.title}{" "}
                                        {row.staff && (
                                          <b>
                                            -{" "}
                                            {
                                              staff?.find(
                                                (s) => s.value == row.staff,
                                              )?.label
                                            }
                                          </b>
                                        )}
                                      </td>

                                      <td className="text-center">
                                        {moment(row.date).format("DD-MM-YYYY")}
                                      </td>

                                      <td className="text-center">
                                        {row.start_time}
                                      </td>

                                      <td className="text-center">
                                        {row.end_time}
                                      </td>

                                      <td className="fw-bold text-primary text-center">
                                        {row.totaltime}
                                      </td>

                                      <td className="text-center">
                                        <span
                                          title={
                                            row.approved == 1
                                              ? "Approved"
                                              : row.approved == 2
                                              ? "Rejected"
                                              : "Pending"
                                          }
                                        >
                                          {row.approved == 1 ? (
                                            <i className="bi bi-check-circle icon-center text-success fs-4 me-2"></i>
                                          ) : row.approved == 2 ? (
                                            <i className="bi bi-x-circle icon-center text-danger fs-4 me-2"></i>
                                          ) : (
                                            <i className="bi bi-exclamation-circle icon-center text-warning fs-4 me-2"></i>
                                          )}
                                          {row.project?.keyAccountManager?.name}
                                        </span>
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>

                              <div className="d-flex justify-content-end mt-3"></div>
                            </div>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="card p-4 h-100">
              <Row>
                <Col className="col-12 hr-report">
                  <Row className="justify-content-center">
                    <div className="col-md-4 d-flex flex-column align-items-center justify-content-center">
                      <img src={viewImg} alt="Image" width={400} />
                      <p className="text-purple fw-bold text-center lh-base">
                        📊 All staff Timesheet data is now available <br />
                        use filters to efficiently search and analyze
                        company-wide records. 📂📈
                      </p>
                    </div>
                  </Row>
                </Col>
              </Row>
            </div>
          )}
        </Container>
      </div>

      {/* List of user who didn't filled timesheet */}
      <Modal isOpen={modal} size="sm" className="" centered>
        <div className="modal-header">
          <h6 className="modal-title mt-0">Check who has not yet submitted</h6>
          <button
            type="button"
            onClick={() => setModal(false)}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div
          className="modal-body"
          style={{ height: "60vh", overflow: "auto", scrollbarWidth: "thin" }}
        >
          <div
            className=" px-2 fw-bold py-1 rounded position-sticky left-0 right-0"
            style={{ backgroundColor: "#f0e8f4", top: "-16px" }}
          >
            Total Users : {users?.filter((u) => !u.isClosed).length}
          </div>
          {users
            ?.filter((u) => !u.isClosed)
            ?.map((u, i) => (
              <div className="py-1" key={u.value}>
                <div className="bg-light px-2 py-2 d-flex justify-content-between align-items-center">
                  {i + 1}. {u.label?.split(" ")?.slice(0, 2)?.join(" ")}
                  <div>
                    {u.isAllowed ? (
                      <button
                        disabled
                        className="btn btn-sm btn-light border  "
                        style={{ color: "green" }}
                        title="Access Provided."
                      >
                        <i className="fas fa-check me-1"></i> Allowed
                      </button>
                    ) : (
                      <button
                        onClick={() => handleAllowFill(u)}
                        className="btn btn-sm btn-light border "
                        title="By clicking, you are enabling user to fill their pending timesheet."
                      >
                        <i className="fas fa-user-lock me-1"></i> Allow
                      </button>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </Modal>
    </React.Fragment>
  );
};

export default TimeSheetReport;
